/**
 * GA4 gereği view_item_list event'inde her event maksimum 8 item içermeli.
 * Bu helper, items array'ini 8'li gruplara böler.
 */
export const chunkItemsForGa = (items, chunkSize = 8) => {
  if (!Array.isArray(items) || items.length === 0) return [];
  const chunks = [];

  for (let i = 0; i < items.length; i += chunkSize) {
    chunks.push(items.slice(i, i + chunkSize));
  }

  return chunks;
};
